import { ActionTab } from '@/components/Shares/ActionTab';
import { Card, Stack } from '@mantine/core';
import { TransactionTable } from './TransactionTable';
const transactionTab = ['all', 'deposit', 'withdraws'];
export const TransactionCard: React.FC = () => {
  return <Card radius={5} bg="var(--navbar-bg-color)" mt={20}>
      <Stack>
        <ActionTab items={transactionTab} activeIndex={0} miw={200} />
        <TransactionTable />
      </Stack>
    </Card>;
};